import React, { useContext } from 'react';
import type { QuestionWrapperComponentProps } from 'src/entrypoints/root/poll';
import { RootContext } from '../../../../contexts/rootContext';
import { useControlsProps } from '../../../../utils/questionPropsHelper';
import { Footer } from '../Footer';
import { QuestionWrapperTemplate } from './QuestionWrapperTemplate';

export const QuestionWrapper: React.FC<QuestionWrapperComponentProps> = props => {
  const { questionType, children } = props;
  const { schemaEngine } = useContext(RootContext);

  const hiddenFooter =
    schemaEngine.hasTrait(questionType, 'HIDDEN_FOOTER_TYPE') ||
    schemaEngine.hasTrait(questionType, 'HIDDEN_QUESTION_TYPE');

  if (hiddenFooter) {
    return children;
  }

  return <QuestionDefaultWrapper {...props}>{children}</QuestionDefaultWrapper>;
};

export const QuestionDefaultWrapper = ({ children, ...props }: QuestionWrapperComponentProps) => {
  const controlProps = useControlsProps(props);

  return (
    <QuestionWrapperTemplate
      {...props}
      footer={controlProps.showFooter && <Footer {...controlProps} alignSurvey={props.alignSurvey} />}
    >
      {children}
    </QuestionWrapperTemplate>
  );
};
